{
  "title": "主題樣式",
  "fontSize": "字型大小",
  "fontSizeOpts": [ "10", "11", "12", "13", "14" ],
  "inputStyle": "輸入框樣式",
  "ripple": "波紋效果",
  "rippleTooltip": "波紋效果的套用必須早於畫面初始時, 切換至其它頁後返回方可生效",
  "theme": "主題"
}